/**
 * @fileoverview The file manage dT Theme cookie based CompareList 
 * dT_General.js, axios, vue libs are dependencies. 
 * @package
 */
class dT_CompareList {

    constructor() {
        this.CompareListData = [];
        this.LOCAL_STORAGE_CompareLIST_KEY = 'shopify-Comparelist';
        this.LOCAL_STORAGE_DELIMITER = ',';
    }

    setListLocalStorageKey(LOCAL_STORAGE_CompareLIST_KEY, LOCAL_STORAGE_DELIMITER) {
        this.LOCAL_STORAGE_CompareLIST_KEY = LOCAL_STORAGE_CompareLIST_KEY;
        this.LOCAL_STORAGE_DELIMITER = LOCAL_STORAGE_DELIMITER;
    }

    async setupGrid(listType) {
        try {
            var Comparelist = this.getComparelist();
            
            if (Comparelist.length === 0) {
                this.CompareListData = [];
                return [];
            }

            var requests = Comparelist.map(function (handle) {
                var productTileTemplateUrl = '/products/' + handle + '?view=json';
                return this.getProductResponse(productTileTemplateUrl);
            }.bind(this));

            var responses = await Promise.all(requests);
            var ComparelistProductCards = responses.join('%$$%');
            var a_ComparelistRecords = ComparelistProductCards.split("%$$%");

            let recordsObj = [];

            if (Array.isArray(a_ComparelistRecords) && a_ComparelistRecords.length) {
                var index = 0;
                a_ComparelistRecords.forEach(record => {
                    if (record && record.trim() !== '') {
                        var a_record = record.split("~~");
                        
                        if (a_record.length >= 15) {
                            var recordObj = {
                                id: a_record[0] || '',
                                product_title: a_record[1] || '',
                                product_handle: a_record[2] || '',
                                product_image: a_record[3] || '',
                                vendor: a_record[4] || '',
                                type: a_record[5] || '',
                                money_price: a_record[6] || '',
                                price_min: a_record[7] || '',
                                price_max: a_record[8] || '',
                                available: a_record[9] || '',
                                price_varies: a_record[10] || '',
                                variant_id: a_record[11] || '',
                                variant_title: a_record[12] || '',
                                sku: a_record[13] || '',
                                description: a_record[14] || '',
                                quantity: "1",
                                product_url: '/products/' + (a_record[2] || '')
                            };
                            recordsObj[index] = recordObj;
                            index = index + 1;
                        }
                    }
                });
            }

            this.CompareListData = recordsObj;
            return recordsObj;

        } catch (error) {
            console.error('Error setting up compare grid:', error);
            this.CompareListData = [];
            return [];
        }
    }

    getCompareListRecords() {
        return this.CompareListData;
    }

    async getProductResponse(url) {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.text();
            return data.replace(/^\s*[\r\n]/gm, '');
        } catch (error) {
            console.error('Error fetching product:', error);
            return '';
        }
    }

    getTotalCount() {
        return this.getComparelist().length;
    }
  
    getComparelist() {
        var Comparelist = localStorage.getItem(this.LOCAL_STORAGE_CompareLIST_KEY) || false;
        if (Comparelist) return Comparelist.split(this.LOCAL_STORAGE_DELIMITER).filter(item => item.trim() !== '');
        return [];
    }

    setComparelist(array) {
        var Comparelist = array.join(this.LOCAL_STORAGE_DELIMITER);
        if (array.length) localStorage.setItem(this.LOCAL_STORAGE_CompareLIST_KEY, Comparelist);
        else localStorage.removeItem(this.LOCAL_STORAGE_CompareLIST_KEY);
        return Comparelist;
    }

    updateComparelist(handle) {
        var Comparelist = this.getComparelist();
        var indexInComparelist = Comparelist.indexOf(handle);
        if (indexInComparelist === -1) Comparelist.push(handle);
        else Comparelist.splice(indexInComparelist, 1);
        return this.setComparelist(Comparelist);
    }

    removeComparet(handle) {
        var Comparelist = this.getComparelist();
        Comparelist = this.remove(Comparelist, handle);
        return this.setComparelist(Comparelist);  
    }

    resetComparelist() {
        return this.setComparelist([]);
    }

    isAddedIntoList(handle) {
        var Comparelist = this.getComparelist();  
        return Comparelist.includes(handle);
    }

    remove(arr) {
        var what, a = arguments, L = a.length, ax;
        while (L > 1 && arr.length) {
            what = a[--L];
            while ((ax = arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
            }
        }
        return arr;
    }
}

class dTXCompare extends HTMLElement {
    constructor() {
        super();

        this.dTCompareList = new dT_CompareList();
        this.dTCompareList.setListLocalStorageKey('dt-compare-list', ',');

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);

        this.addCompareList = this.querySelector('.add-compare');
        if (this.addCompareList) {
            this.productHandle = this.addCompareList.getAttribute('data-product_handle');
            this.addCompareList.addEventListener('click', this.debouncedOnSubmit.bind(this));
            this.initLoad();
        }
    }

    onSubmitHandler(event) {
        event.preventDefault();

        if (!this.productHandle) {
            console.error('No product handle found');
            return;
        }

        if (this.dTCompareList.isAddedIntoList(this.productHandle)) {
            window.location = "/pages/compare";
        } else {
            const CompTotal = this.dTCompareList.getTotalCount();
            console.log("CompTotal==" + CompTotal);
            
            if (CompTotal >= 4) {
                this.showCompareModal();
                console.log("Compare limit reached. Product not added: " + this.productHandle);
                return;
            } else {
                this.addCompareList.classList.add("adding");
                this.dTCompareList.updateComparelist(this.productHandle);
                setTimeout(this.postAdd.bind(this), 1000);
            }
        }
    }

    showCompareModal() {
        var CompareModal = document.getElementById("compareModal");
        if (CompareModal) {
            var XBtn = document.getElementById("compareModalClose");
            document.querySelector('body').classList.add('alert-overlay-wrapper');
            CompareModal.style.display = "block";
            if (XBtn) {
                XBtn.onclick = function() {
                    CompareModal.style.display = "none";
                    document.querySelector('body').classList.remove('alert-overlay-wrapper');
                }
            }
        } else {
            console.warn('Compare modal not found');
        }
    }

    postAdd() {
        var dtxCount = document.getElementsByClassName('dtxc-compare-count');
        if (dtxCount.length > 0) {
            document.querySelector(".dtxc-compare-count").setAttribute('count', this.dTCompareList.getTotalCount());
        }
        this.addCompareList.classList.remove("adding");
        this.addCompareList.classList.add("added");
        
        // Update count display
        var countBubbles = document.querySelectorAll('.grid-count-bubble span');
        countBubbles.forEach(bubble => {
            bubble.innerHTML = this.dTCompareList.getTotalCount();
        });
    }

    initLoad() {
        if (this.dTCompareList.isAddedIntoList(this.productHandle)) {
            this.addCompareList.classList.add("added");
        }
    }
}

customElements.define('dtx-compare', dTXCompare);

class dTXComparetGrid extends HTMLElement {
    constructor() {
        super();
        this.gridTemplate = this.querySelector('.grid_template');
        this.dtxTable = this.querySelector(".dtx-table");
        this.dtxNoRecord = this.querySelector(".dtx-grid-empty");
        this.grid_type = this.getAttribute('grid_type');
    }

    async initLoad() {
        var dTCompareList = new dT_CompareList();
        if ("compareList" == this.grid_type) {
            dTCompareList.setListLocalStorageKey('dt-compare-list', ',');
        }
        
        try {
            const data = await dTCompareList.setupGrid();
            this.generateGrid(data);
        } catch (error) {
            console.error('Error loading compare grid:', error);
            this.showNoRecords();
        }
    }

    generateGrid(a_records) {
        if (!a_records || a_records.length === 0) {
            this.showNoRecords();
            return;
        }

        // Clear existing rows except header
        if (this.dtxTable) {
            while (this.dtxTable.rows.length > 1) {
                this.dtxTable.deleteRow(1);
            }

            a_records.forEach(record => {
                if (record && record.product_handle) {
                    var newRow = this.dtxTable.insertRow(this.dtxTable.rows.length);
                    newRow.id = 'row_' + record.id;
                    newRow.innerHTML = this.buidRow(record);
                }
            });

            this.dtxNoRecord.classList.add("dtx-grid-hide");
            this.dtxTable.classList.add("dtx-grid-show");
        }
    }

    buidRow(record) {
        if (!this.gridTemplate) return '';
        
        var templateData = this.gridTemplate.innerHTML;
        
        // Use proper template variable replacement
        const replacements = {
            '{item.product_handle}': record.product_handle || '',
            '{item.product_url}': record.product_url || '',
            '{item.product_image}': record.product_image || '',
            '{item.product_title}': record.product_title || '',
            '{item.money_price}': record.money_price || '',
            '{item.variant_id}': record.variant_id || '',
            '{item.product_type}': record.type || 'Nil',
            '{item.product_sku}': record.sku || 'Nil',
            '{item.product_vendor}': record.vendor || 'Nil',
            '{item.product_description}': record.description || 'Nil',
            '{item.available}': record.available === 'true' ? (window.DT_THEME?.strings?.in_stock || 'In Stock') : (window.variantStrings?.soldOut || 'Sold Out')
        };

        Object.keys(replacements).forEach(key => {
            templateData = templateData.replace(new RegExp(key, 'gi'), replacements[key]);
        });

        return templateData;
    }

    showNoRecords() {
        if (this.dtxTable) this.dtxTable.classList.add("dtx-grid-hide");
        if (this.dtxNoRecord) this.dtxNoRecord.classList.add("dtx-grid-show");
    }

    connectedCallback() {
        this.initLoad();
    }
}

customElements.define('dtx-compare-grid', dTXComparetGrid);

class dTXRemoveCompareItem extends HTMLElement {
    constructor() {
        super();
        this.removeItem = this.querySelector('.remove-item');
        this.debouncedOnSubmit = debounce((event) => {
            this.removeListItem(event);
        }, 500);
        this.grid_type = this.getAttribute('grid_type');
        
        if (this.removeItem) {
            this.productHandle = this.removeItem.getAttribute('data-product_handle');
            this.removeItem.addEventListener('click', this.debouncedOnSubmit.bind(this));
        }
    }

    removeListItem(event) {
        event.preventDefault();
        var dTCompareList = new dT_CompareList();
        if ("compareList" == this.grid_type) {
            dTCompareList.setListLocalStorageKey('dt-compare-list', ',');
        }
        dTCompareList.removeComparet(this.productHandle);
        window.location.reload();
    }
}

customElements.define('dtx-remove-compare-item', dTXRemoveCompareItem);

class dTXCompareCount extends HTMLElement {
    static get observedAttributes() {
        return ['count'];
    }

    constructor() {
        super();
        this.gridCountBubble = this.querySelector('.grid-count-bubble');
        this.grid_type = this.getAttribute('grid_type');
        this.initLoad();
    }

    initLoad() {
        var dTCompareList = new dT_CompareList();
        if ("compareList" == this.grid_type) {
            dTCompareList.setListLocalStorageKey('dt-compare-list', ',');
        }
        
        var totalCount = dTCompareList.getTotalCount();
        
        if (this.gridCountBubble) {
            const countSpan = this.gridCountBubble.querySelector("span");
            if (countSpan) {
                countSpan.innerHTML = totalCount;
            }
            
            const compareCount = document.querySelector('.dtxc-compare-count');
            if (compareCount) {
                if (parseInt(totalCount) == 0) {
                    compareCount.classList.add('count-zero');
                    compareCount.classList.remove('count-exist');
                } else {
                    compareCount.classList.add('count-exist');
                    compareCount.classList.remove('count-zero');
                }
            }
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        this.initLoad();
    }
}

customElements.define('dtx-compare-count', dTXCompareCount);